import { useNavigate, useParams } from "react-router-dom";
import "../../styles/pages.css";
import Banner from "../ui/Banner";
import ceo from "../../assets/images/ceo.png";
import about from "../../assets/images/about.png";
import historyimg from "../../assets/images/historyimg.png";

const EnAbout = () => {
  const navigate = useNavigate();
  const { tab } = useParams();
  const activeTab = tab || "greeting";

  const handleTabChange = (tabId) => {
    navigate(`/en/about/${tabId}`);
  };

  const bannerConfig = {
    backgroundImage: about,
    title: "Company introduction",
    description: [
      "ECOTECH GLOBAL will train customized engineers to meet the reality of domestic facility farmers",
      "Innovative greenhouse management solutions support increasing farm household income.",
    ],
    tabs: [
      { id: "greeting", name: "greeting" },
      { id: "history", name: "history" },
    ],
  };

  return (
    <div className="about-container">
      <Banner {...bannerConfig} activeTab={activeTab} onTabChange={handleTabChange} />
      {activeTab === "greeting" && <GreetingContent />}
      {activeTab === "history" && <HistoryContent />}
    </div>
  );
};

const GreetingContent = () => (
  <div className="greeting-section">
    <div className="greeting-header">
      <h2>
        The future of the greenhouse
        <br />
        in the facility is
        <br />
        ECOTECH GLOBAL will open up.
      </h2>
    </div>

    <div className="greeting-content">
      <div className="greeting-text">
        <div className="gretting-text-bg">
          <div className="text-container">
            <p>Thank you to everyone who joined us in the growth of ECOTECH GLOBAL </p>
            <p>We will repay you with more diverse and differentiated services.</p>
            <div className="ceo-image">
              <img src={ceo} alt="에코텍글로벌 대표 강병욱" />
            </div>
          </div>
        </div>
        <div className="company-description">
          <p>
            In 20 years, technology, technology, technology, technology, and know-how, providing comprehensive services from greenhouse construction, and provide comprehensive services from greenhouse
            construction Also, we provide a lot of benefits to develop advanced technology as the introduction of advanced technology.Improve the growth environment and holding engineering engineering
            engine's expertise and holding engineering It is not only contributed to economic ripple effect, and job creation, job creation, job creation, job creation, job creation and jobs.
          </p>
          <p>
            We have steadily tried to improve the size of the domestic facilities and reality of engine
            <br /> I tried to develop quality products and creative thinking and creativity, and creative ideas, and creative ideas.
          </p>
          <p> In the future, I'll be an eco-friendly eco-friendly greenhouse management of facilities and greenhouse officials.</p>
        </div>
        <div className="ceo-signature">
          <p>
            CEO of ECOTECH GLOBAL<strong>Kang Byung-wook</strong>
          </p>
        </div>
      </div>
    </div>
  </div>
);

const HistoryContent = () => (
  <>
    <div className="history-section">
      <h2>corporate information</h2>
      <div className="company-info-container">
        <div className="company-info-left">
          <div className="info-row">
            <div className="info-content">
              <div className="info-title">Company Name</div>
              <div className="info-value" style={{ marginLeft: 0 }}>
                ECOTECH GLOBAL Co., Ltd
              </div>
            </div>
          </div>

          <div className="info-row">
            <div className="info-content">
              <div className="info-title">CEO</div>
              <div className="info-value" style={{ marginLeft: 0 }}>
                Kang Byung-wook
              </div>
            </div>
          </div>

          <div className="info-row">
            <div className="info-content">
              <div className="info-title">Founding date</div>
              <div className="info-value" style={{ marginLeft: 0 }}>
                On March 26, 2012
              </div>
            </div>
          </div>
        </div>

        <div className="company-info-right">
          <img src={historyimg} alt="회사 건물 이미지" className="company-building" />
        </div>
      </div>
      <div className="company-history">
        <div className="text-container">
          <p>ECOTECH GLOBAL HISTORY</p>
          <p>ECOTECH GLOBAL, which started as a creative company, started as a creative company in 2008, Currently, it became a facility expert company.</p>
        </div>
      </div>
    </div>
    <div className="history-timeline">
      <div className="timeline-period">
        <div className="period-year">2022 ~ 2025</div>
        <div className="period-events">
          <div className="event-item">Establishment of Technopark Factory in Chirchiq City, Uzbekistan</div>
          <div className="event-item">The award ceremony #1, the Small and Medium Business Center / commendation #2</div>
          <div className="event-item">establishment of the corporate department</div>
          <div className="event-item">Three technology in Jeonbuk University</div>
          <div className="event-item">MOU signed with Mongolian EUN-HEA Farm</div>
          <div className="event-item">Main-Biz authentication +INNOBiz authentication</div>
          <div className="event-item">a member of the Chamber of Commerce</div>
          <div className="event-item">Signed an MOU with the Mongolian Institute of Plant and Biotechnology (IPAS) for a pilot project for an open-field smart farm platform</div>
          <div className="event-item">Acquired ISO 9001 and 14001 certifications</div>
        </div>
      </div>
      <div className="timeline-period">
        <div className="period-year">2018 ~ 2021</div>
        <div className="period-events">
          <div className="event-item">Participation participating in the Urban Development of Artificial Development</div>
          <div className="event-item">Development of Korea's First Agricultural Crop Crushing Machine</div>
          <div className="event-item">Commercialization of Korea's first aging glass greenhouse remodeling technology</div>
          <div className="event-item">establishment of the domestic car Gwangmyeongje</div>
        </div>
      </div>
      <div className="timeline-period">
        <div className="period-year">2016 ~ 2017</div>
        <div className="period-events">
          <div className="event-item">patent #1. plastic house light and manufacturing method</div>
          <div className="event-item">Patent #2. Water housing patent</div>
          <div className="event-item">Patent #3. Opening and closing system of greenhouse ceilings that can be controlled individually by multiple ceilings</div>
          <div className="event-item">Royal Brinkman Korea Branch, Netherlands</div>
        </div>
      </div>
      <div className="timeline-period">
        <div className="period-year">2013 ~ 2015</div>
        <div className="period-events">
          <div className="event-item">Established Eco Farm Co., Ltd</div>
          <div className="event-item">Corporation specializing in shading and greenhouse construction</div>
          <div className="event-item">Technology guarantee company registration as venture company</div>
        </div>
      </div>
      <div className="timeline-period">
        <div className="period-year">2008</div>
        <div className="period-events">
          <div className="event-item">Jeonju University Venture No. 1</div>
          <div className="event-item">A company specializing in the development and construction and installation of light blockers for vinyl greenhouses</div>
        </div>
      </div>
    </div>
  </>
);

export default EnAbout;
